import { render } from "./RetrievePass.vue?vue&type=template&id=44aa2682&scoped=true&ts=true"
import script from "./RetrievePass.vue?vue&type=script&lang=ts"
export * from "./RetrievePass.vue?vue&type=script&lang=ts"

import "./RetrievePass.vue?vue&type=style&index=0&id=44aa2682&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Basseliersstraat\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44aa2682"]])

export default __exports__